import {share} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {getMessageFromException} from '../utilities/Util';
import {NotificationService} from './NotificationService';
import {LookUp, LookUpClient, PagedListOfLookUp} from './api.client';

import {LookUpCategoryType} from './api.client';
import {Observable} from 'rxjs';
// api
// models
// enums

// 003-retire-ngrx (US1): the lookup slice was component-local in all but name
// (single consumer: LookUpComponent), so the store round-trip is gone — fetch
// methods return the API observable and the component owns the page state.
@Injectable()
export class LookUpService {

  constructor(private _lookupApiService: LookUpClient,
              private _notificationService: NotificationService) {
  }

  addLookUp(lookup: LookUp): Observable<LookUp> {
    const request = this._lookupApiService.addLookUp(lookup).pipe(share());
    this._notificationService.showSuccess('Attempting to save new Look Up.');
    request.subscribe({ next: () => {
      this._notificationService.showSuccess('LookUp Successfully Created!');
    }, error: (err) => {
        this._notificationService.showError(getMessageFromException(err));
    }, complete: () => {

    }});

    return request;
  }

  updateLookUp(lookup: LookUp): Observable<LookUp> {
    const request = this._lookupApiService.updateLookUp(lookup).pipe(share());
    this._notificationService.showSuccess('Attempting to update Look Up.');
    request.subscribe({ next: () => {
      this._notificationService.showSuccess('LookUp Succesfully Updated!');
    }, error: () => {
      this._notificationService.showError('There was a problem updating this LookUp.');
    }, complete: () => {

    }});
    return request;
  }

  deleteLookUp(id: string): Observable<boolean> {
    const request = this._lookupApiService.deleteLookUp(id).pipe(share());
    this._notificationService.showSuccess('Attempting to delete LookUp.');
    request.subscribe({ next: () => {
      this._notificationService.showSuccess('LookUp Successfully Deleted!');
    }, error: () => {
      this._notificationService.showError('There was a problem deleting this LookUp');
    }, complete: () => {

    }});
    return request;
  }

  getLookUps(categoryType: LookUpCategoryType, sortName: string, sorting: boolean, limit: number, offset: number): Observable<PagedListOfLookUp> {
    const request = this._lookupApiService.retrieveLookUps(
      categoryType,
      limit || 10,
      offset || 0,
      sortName,
      null,
      sorting
    ).pipe(share());
    request.subscribe({ next: () => {
    }, error: (err) => {
        this._notificationService.showError(getMessageFromException(err));
    }, complete: () => {

    }});
    return request;
  }
}
